/**
 * CockpitLoaderOverlay — root-level mount point for the cockpit loader.
 * Subscribes to useTransitionLoader and renders <CockpitLoader> when
 * `isVisible` is true. Mount this exactly once, near the App root.
 *
 * The loader's onComplete dispatches store.complete(), which:
 *   1. unmounts this overlay (so the destination page renders),
 *   2. fires whatever onComplete callback was queued at show() time
 *      (typically a router navigate).
 */

import { useTransitionLoader } from '../../stores/transitionLoaderStore';
import CockpitLoader from './CockpitLoader';

export default function CockpitLoaderOverlay() {
  const isVisible = useTransitionLoader((s) => s.isVisible);
  const variant = useTransitionLoader((s) => s.variant);
  const complete = useTransitionLoader((s) => s.complete);

  if (!isVisible) {return null;}

  return <CockpitLoader onComplete={complete} variant={variant} />;
}
